
export default function InverterBorder({ plotdata }) {
    const BorderArray = (plotdata) => {
        let tmp = []
        if (plotdata.border !== null && plotdata.border !== undefined) {
            for (let i = 0; i < plotdata.border?.length; i++) {
                if (i > 0) {
                    let x1 = plotdata.border[i - 1].x
                    let y1 = plotdata.border[i - 1].y
                    let x2 = plotdata.border[i].x
                    let y2 = plotdata.border[i].y

                    if (y2 !== y1) { //vertical
                        let p_l = x1
                        let p_t = y1 - 4
                        let h = (y2 - y1) + 4
                        if (y2 < y1) { // bottom to top
                            p_l = x2
                            p_t = y2 - 4
                            h = (y1 - y2) + 4
                        }
                        tmp.push(<div className={'inverter-border-vertical-' + plotdata.border_type} key={i}
                            style={{
                                left: p_l + "px",
                                top: p_t + "px",
                                height: h + "px"
                            }}
                        ></div >)
                    } else { //Horizontal
                        let p_l = x1
                        let p_t = y1
                        let w = (x2 - x1)
                        if (x2 < x1) { // right to left
                            p_l = x2
                            p_t = y2
                            w = (x1 - x2)
                        }
                        tmp.push(<div className={'inverter-border-horizontal-' + plotdata.border_type} key={i}
                            style={{
                                left: p_l + "px",
                                top: p_t + "px",
                                width: w + "px"
                            }}
                        ></div >)
                    }
                }
            }
        }
        return tmp
    }

    return (
        plotdata?.border !== undefined ?
            <>
                {BorderArray(plotdata)}
            </>
            :
            null
    )
}
